export default function IndustriesPage(){
    return(
        <>
         <section id="industries-page" className="industries-page">
        <div className="container aos-init aos-animate" data-aos="fade-up">

            <div className="section-title aos-init aos-animate" data-aos="fade-in" data-aos-delay="100">
                <h2>Our Industries</h2>
                <p className="mb-sm-5 mb-3">Through years of hard work and dedication, Golden Exports has established itself as a leader in
                    various industries like garment, furniture, and commodities.
                    We have cultivated a deep understanding of these industries, allowing us to navigate
                    complexities and deliver exceptional services to our customers. We have diversified our services
                    into various industries like:</p>
            </div>
   
            <div className="row g-0 flex-row-reverse">
                <div className="col-lg-6">
                    <div className="industries-img">
                        <img src="assets/images/our_industries/GARMENTS.webp"  className="img-fluid"/>
                    </div>

                </div>

                <div className="col-lg-6">
                    <div className="content d-flex flex-column justify-content-center h-100">
                        <h3>GARMENTS</h3>

                        <p> Golden Exports have emerged as a prime player in the manufacturing of outerwear and knitwear
                            clothing for men,women, and children. We serve distinguished markets in Italy, Ireland,
                            Russia, and the United States of America. </p>

                        <p> Through our vast global distribution network and commitment to serving diverse markets, we
                            have engaged in the manufacturing of clothing for Diesel's Ireland Division.</p>

                        <p>Our extensive expertise in the garment industry has enabled us to cater to a wide range of
                            fashion preferences and styles while meeting the distinct needs of our customers.</p>
                    </div>
                </div>
            </div>

            <div className="row g-0 ">
                <div className="col-lg-6">
                    <div className="industries-img">
                        <img src="assets/images/our_industries/tools.webp"  className="img-fluid"/>
                    </div>

                </div>
                <div className="col-lg-6">
                    <div className="content d-flex flex-column justify-content-center h-100">
                        <h3>TOOLS</h3>
                        <p> After recognizing the growing demand and potential within the market, we expanded our
                            manufacturing capabilities in 2020 and ventured into the production of hand tools and tool
                            cabinets. This strategic move allowed us to diversify our product offerings. </p>

                        <p> We can proudly say that we are distributing our range of products across Europe, catering to
                            diverse clientele like wholesalers, original equipment manufacturers (OEMs), and traditional
                            brick-and-mortar stores.</p>


                    </div>
                </div>
            </div>

            <div className="row g-0 flex-row-reverse">
                <div className="col-lg-6">

                    <div className="industries-img">
                        <img src="assets/images/our_industries/FURNITURE.webp"  className="img-fluid"/>
                    </div>

                </div>

                <div className="col-lg-6">
                    <div className="content d-flex flex-column justify-content-center h-100">
                        <h3>FURNITURE</h3>
                        <p> Golden Exports is currently supplying a comprehensive range of high-quality office furniture
                            in Saudi Arabia. Our product line includes a wide range of products that are not only
                            stylish but functional too. They are designed with meticulous attention to detail and
                            appeal. </p>

                    </div>
                </div>
            </div>

            <div className="row g-0 ">
                <div className="col-lg-6">
                    <div className="industries-img">
                        <img src="assets/images/our_industries/COMMODITIES.webp"  className="img-fluid"/>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="content d-flex flex-column justify-content-center h-100">
                        <h3>COMMODITIES</h3>
                        <p> To strengthen our position in global markets we expanded our service basket - we are
                            currently exporting sugar from Brazil, aluminium & quartz stone from India, and copper from
                            Africa. </p>

                        <p> By partnering with reliable producers, we ensure a steady supply of premium-quality material
                            that not only meets international standards but the diverse needs of our customers too. </p>

                        <p> We remain committed to delivering exceptional products & services to our customers while
                            maintaining strong relationships with our business partners.</p>

                    </div>
                </div>
            </div>



        </div>
    </section>
        </>
    );
}